class MAskQuestion extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      openButton: "[data-open-ask-question]",
      content: ".m-form-ask-question",
      container: ".m-product-addon",
      formSuccess: ".form-ask__success",
    };
  }

  connectedCallback() {
    this.domNodes = queryDomNodes(this.selectors, this);
    this.container = document.querySelector(this.selectors.container);
    this.colorScheme = this.domNodes.content.dataset.colorScheme;
    if (this.domNodes.content && this.domNodes.content.innerHTML) {
      this.content = this.domNodes.content.innerHTML;
      this.init();
    }
  }

  init() {
    this.showSuccessMessage();
    this.modal = new MinimogTheme.Modal();
    addEventDelegate({
      selector: this.selectors.openButton,
      handler: (e) => {
        e.preventDefault();
        if (this.content) {
          const html = document.createElement("DIV");
          html.innerHTML = this.content;

          const form = html.querySelector("#contact-form-ask");
          if (form) {
            form.addEventListener("submit", (e) => {
              emailjs.init("pCiWGSTeWq98pUUTu");
              const customerEmail = form.querySelector(
                'input[name="contact[email]"]'
              ).value;
              const customerName =
                form.querySelector('input[name="contact[name]"]')?.value ||
                "Customer";
              const customerPhone =
                form.querySelector('input[name="contact[phone]"]')?.value ||
                "12345678";
              const customerCountry =
                form.querySelector('select[name="contact[country]"]')?.value ||
                "Austria";
              const customerAddress =
                form.querySelector('input[name="contact[address]"]')?.value ||
                "";
              const customerZip =
                form.querySelector('input[name="contact[zip]"]')?.value || "";
              const customerCity =
                form.querySelector('input[name="contact[city]"]')?.value || "";
              const customerQuestion =
                form.querySelector('textarea[name="contact[question]"]')
                  ?.value || "";

              const productTitle = form.querySelector(
                'input[name="contact[product]"]'
              ).value;
              const variantSelector = document.querySelector(
                ".main-product__block-variant_picker"
              );
              const selectedInputs = variantSelector.querySelector(
                'input[type="radio"]:checked'
              );
              const label = variantSelector.querySelector(
                `label[for="${selectedInputs.id}"]`
              );
              const variantText = label?.textContent.trim();

              const price = form.querySelector(
                'input[name="contact[product price]"]'
              ).value;

              emailjs
                .send("service_5rdrgpg", "template_yfvh60h", {
                  product: productTitle,
                  variant: variantText,
                  price: price,
                  quanity: 1,
                  email: customerEmail,
                  name: customerName,
                  phone: customerPhone,
                  country: customerCountry,
                  address: customerAddress,
                  zip: customerZip,
                  city: customerCity,
                  question: customerQuestion,
                })
                .then(() => {
                  console.log(`confirmation email sent to customer`);
                  window.location.href = "/pages/vielen-dank-fur-ihre-anfrage";
                })
                .catch((error) => {
                  console.log(`EmailJS error: `, error);
                  window.location.href = "/pages/vielen-dank-fur-ihre-anfrage";
                });
            });
          }

          this.modal.appendChild(html);
          this.modal.setWidth("500px");
          this.modal.setSizes(
            `m-form-ask-question m-gradient ${this.colorScheme}`
          );
          this.container.classList.remove("m:hidden");
          this.modal.open();
        }
      },
    });
  }
  showSuccessMessage() {
    const successMessage = this.container.querySelector(
      this.selectors.formSuccess
    );
    if (successMessage) {
      MinimogTheme.Notification.show({
        target: document.body,
        method: "appendChild",
        type: "success",
        message: successMessage.dataset.message,
        delay: 2000,
        sticky: true,
      });

      setTimeout(() => {
        const url = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, url);
      }, 2500);
    }
  }
}
customElements.define("m-ask-question", MAskQuestion);
